import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import {
  faCalendar,
  faFolder,
  faEnvelope,
  // faHouse,
  faList,
  faUsers,
  faSignal,
} from '@fortawesome/pro-regular-svg-icons';
import { Tabs, TabsList, TabsTrigger } from '@rocketlane/ui';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes/route-paths';
import { IconWrapper } from 'components/common/styles';

export enum AccountsTabsType {
  Home = 'home',
  Timeline = 'timeline',
  MeetingsPages = 'meetings-pages',
  People = 'people',
  Spaces = 'spaces',
  AllSignals = 'all-signals',
  Email = 'email',
  SignalsV2 = 'signals-v2',
}

interface AccountsTabsProps {
  activeKey: AccountsTabsType;
}
const getRelativeUrl = (key: AccountsTabsType) => {
  switch (key) {
    case AccountsTabsType.Home:
      return '';
    case AccountsTabsType.Timeline:
      return ROUTE_PATHS.ACCOUNT_DETAIL_TIMELINE;
    case AccountsTabsType.MeetingsPages:
      // TODO: consume it from the route navigations
      return ROUTE_PATHS.ACCOUNT_DETAIL_MEETINGS.replace('/:meetingId?', '');
    case AccountsTabsType.People:
      return `${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE}/${ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_LIST}`;
    case AccountsTabsType.Spaces:
      return ROUTE_PATHS.ACCOUNT_DETAIL_SPACES.replace(
        '/:spaceDocumentId?',
        '',
      );
    case AccountsTabsType.Email:
      return ROUTE_PATHS.ACCOUNT_DETAIL_EMAILS.replace('/:emailId?', '');
    case AccountsTabsType.AllSignals:
      return ROUTE_PATHS.ALL_SIGNALS;
    case AccountsTabsType.SignalsV2:
      return ROUTE_PATHS.SIGNALS_V2;
  }
};

const accountTabs = [
  // {
  //   key: AccountsTabsType.Home,
  //   label: <FormattedMessage id="accounts.page.homepage.title" />,
  //   icon: <FontAwesomeIcon icon={faHouse} />,
  // },
  {
    key: AccountsTabsType.Timeline,
    label: <FormattedMessage id="accounts.page.timeline.title" />,
    icon: <FontAwesomeIcon icon={faList} />,
  },
  {
    key: AccountsTabsType.People,
    label: <FormattedMessage id="accounts.page.people.title" />,
    icon: <FontAwesomeIcon icon={faUsers} />,
  },
  {
    key: AccountsTabsType.MeetingsPages,
    label: <FormattedMessage id="accounts.page.meeting_pages.title" />,
    icon: <FontAwesomeIcon icon={faCalendar} />,
  },
  {
    key: AccountsTabsType.Spaces,
    label: <FormattedMessage id="accounts.page.spaces.title" />,
    icon: <FontAwesomeIcon icon={faFolder} />,
  },
  // {
  //   key: AccountsTabsType.AllSignals,
  //   label: <FormattedMessage id="accounts.page.all_signals.title" />,
  //   icon: <FontAwesomeIcon icon={faSignal} />,
  // },
  {
    key: AccountsTabsType.SignalsV2,
    label: <FormattedMessage id="accounts.page.all_signals.title" />,
    icon: <FontAwesomeIcon icon={faSignal} />,
  },
  {
    key: AccountsTabsType.Email,
    label: <FormattedMessage id="accounts.page.email.title" />,
    icon: <FontAwesomeIcon icon={faEnvelope} />,
  },
];

export const AccountsTabs = ({ activeKey }: AccountsTabsProps) => {
  const { accountId } = useParams<{ accountId: string }>();
  const navigate = useNavigate();

  const handleTabChange = useCallback(
    (key: string) => {
      if (accountId == null) {
        return;
      }
      const relativeUrl = getRelativeUrl(key as AccountsTabsType);
      const baseUrl = ROUTE_PATHS.ACCOUNT_DETAIL.replace(
        ':accountId',
        accountId,
      );

      navigate(`/${ROUTE_PATHS.ACCOUNTS}/${baseUrl}/${relativeUrl}`);
    },
    [navigate, accountId],
  );

  return (
    <Tabs
      className="h-[40px]"
      value={activeKey}
      onValueChange={handleTabChange}
    >
      <TabsList>
        {accountTabs.map((tab) => (
          <TabsTrigger
            key={tab.key}
            value={tab.key}
            icon={<IconWrapper>{tab.icon}</IconWrapper>}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
